import type { DriveContext, GoogleDriveFile } from './types';
import { googleFetch } from '../client';

export type GoogleDriveFilesGetRequest = DriveContext & {
  file_id: string;
  format?: 'json' | 'text';
};

export type GoogleDriveFilesGetResponse = {
  metadata: GoogleDriveFile;
  content?: string | Record<string, unknown> | null;
};

export async function googleDriveFilesGet(
  params: GoogleDriveFilesGetRequest
): Promise<GoogleDriveFilesGetResponse> {
  return googleFetch<GoogleDriveFilesGetResponse>('/rpc/google_drive_files_get', {
    body: params,
  });
}
